import { Icon, IconName } from '@payflip/ui';
import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router';
import { message } from '../../utils/message';
import { LocaleContext } from '../locale-provider';
import { getStaticProps } from '../nav/get-static-props';
import { useGetCartChoicesCountQuery } from '../nav/queries.generated';
import { Badge, IconWrapper, Link, Wrapper } from './styled';

export function MobileNav(): JSX.Element | null {
  const { locale } = useContext(LocaleContext);
  const { data: staticProps } = useQuery(['navigation', locale], () =>
    getStaticProps(locale)
  );

  const location = useLocation();

  const { data } = useGetCartChoicesCountQuery({
    fetchPolicy: 'cache-and-network'
  });

  const choicesToCheckoutCount = useMemo(() => {
    if (typeof data !== 'object') {
      return 0;
    }

    return data.choices.length;
  }, [data]);

  const cmsData = useMemo(() => {
    if (typeof staticProps === 'undefined') {
      return null;
    }

    return staticProps.props.data.employeeNavigation.data?.attributes ?? null;
  }, [staticProps]);

  if (typeof staticProps === 'undefined') {
    return null;
  }

  return (
    <Wrapper>
      <Link to="/" selected={location.pathname === '/'}>
        <IconWrapper selected={location.pathname === '/'}>
          <Icon name={IconName.Home} />
        </IconWrapper>
        <span>{message(cmsData?.overviewLinkText, 'Overview')}</span>
      </Link>
      <Link to="/benefits" selected={location.pathname.startsWith('/benefits')}>
        <IconWrapper selected={location.pathname.startsWith('/benefits')}>
          <Icon name={IconName.LocalOffer} />
        </IconWrapper>
        <span>{message(cmsData?.benefitsLinkText, 'Benefits')}</span>
      </Link>
      <Link
        to="/your-space"
        selected={location.pathname.startsWith('/your-space')}
      >
        <IconWrapper selected={location.pathname.startsWith('/your-space')}>
          <Icon name={IconName.Grid} />
        </IconWrapper>
        <span>{message(cmsData?.yourSpaceLinkText, 'Your space')}</span>
      </Link>
      <Link to="/cart" selected={location.pathname.startsWith('/cart')}>
        <IconWrapper selected={location.pathname.startsWith('/cart')}>
          <Icon name={IconName.Basket} />
          {choicesToCheckoutCount > 0 && <Badge />}
        </IconWrapper>
        <span>{message(cmsData?.cartLinkText, 'Cart')}</span>
      </Link>
    </Wrapper>
  );
}
